export const SELECTION_KEY = 'manage-entitlements';
export const SECTION_NAME = 'Roles, Grants & Resources';
export const NO_ASSIGNED_ENTITLEMENT_TITLE =
    'There are currently no resources assigned to this account. ' +
    'Please use the "Assign Resource(s)" button to assign access to a new resource.';

export const NO_ASSIGNED_ENTITLEMENT_DESCRIPTION =
    'If you do not have access to the "Assign Resource(s)" button on this page, ' +
    'please reach out to the PB Admin team to request an entitlement update.';

export const COLUMNS = {
    TITLE: 'title',
    DESCRIPTION: 'description',
    GRANT: 'grant',
    STATUS: 'status',
    RESTRICTION: 'restriction',
};

export const HEADERS = {
    [COLUMNS.TITLE]: 'Role/Resource',
    [COLUMNS.DESCRIPTION]: 'Description',
    [COLUMNS.GRANT]: 'Entitlement Grant',
    [COLUMNS.STATUS]: 'Status',
    [COLUMNS.RESTRICTION]: 'Restriction',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.TITLE,
        fixed: true,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.DESCRIPTION,
        fixed: false,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.GRANT,
        fixed: false,
        defaultWidth: 400,
        minWidth: 350,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.STATUS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 400,
    },
    {
        columnId: COLUMNS.RESTRICTION,
        fixed: false,
        defaultWidth: 260,
        minWidth: 260,
        maxWidth: 500,
    },
];

export const MAX_SELECTED_ENTITLEMENTS = 250;
